import React from 'react';

import "@Assets/@Styles/@index.scss";

import CookieConsent from "react-cookie-consent";

import {
    BrowserRouter as Router,
    Routes, Route, useSearchParams,
} from "react-router-dom";

import ApplicationHeader from "./Parts/@Header";
import ApplicationFooter from "./Parts/@Footer";

import HomePage from "./Pages/@HomePage";
import ContactUs from "@Pages/ContactUs";

import HowItWorksPage from "@Pages/HowItWorks";
import FAQPage from "@Pages/FAQ";

import SecurityPage from "@Pages/Security";

import PrivacyPolicyPage from "@Pages/@LegalPages/PrivacyPolicy";
import TermsOfServicePage from "@Pages/@LegalPages/TermsOfService";
import AntiHarassmentPage from "@Pages/@LegalPages/AntiHarassment";

import JoinQyvoPage from "@Pages/JoinQyvo/";

import {
    SignInPage,
} from "@Pages/@@UserPages";

import {
    UserDashboardPage,
} from "@Pages/@@UserPages/@@Dashboard";


export const ApplicationComponent = () => {

    return (

        <Router>

            <ApplicationHeader />

            <Routes>

                <Route path={'/'} element={<HomePage />} />
                <Route path={'/contact-us'} element={<ContactUs />} />
                <Route path={'/join-qyvo'} element={<JoinQyvoPage />} />

                <Route path={'/how-it-works'} element={<HowItWorksPage />} />
                <Route path={'/faq'} element={<FAQPage />} />

                <Route path={'/security'} element={<SecurityPage />} />

                <Route path={'/privacy-policy'} element={<PrivacyPolicyPage />} />
                <Route path={'/terms-of-service'} element={<TermsOfServicePage />} />
                <Route path={'/anti-harassment'} element={<AntiHarassmentPage />} />

                <Route path={'/sign-in'} element={<SignInPage />} />
                <Route path={'/dashboard/*'} element={<UserDashboardPage />} />

            </Routes>

            <ApplicationFooter />

            <CookieConsent
                buttonText="I Accept all"
                declineButtonText="I decline"
                declineCookieValue={'I decline'}
                setDeclineCookie={true}
            >
                We use cookies to improve your browsing experience, display personalized advertising or content, and analyze site traffic. By clicking "Accept all," you consent to our use of cookies.
            </CookieConsent>

        </Router>

    );

};


export default ApplicationComponent;
